/**
 * Desc: 文件管理
 */

import React, {Component} from 'react'
import ImagesViewer from "../../components/imagesVIewer";
import {getArrayValue, getIntValue, getSearchParams, getStrValue, isObjEmpty} from "../../utils/common";
import NotifyBoBean from "../../model/NotifyBoBean";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import {List, Icon} from 'antd'
import {Toast} from 'antd-mobile'
import {connect} from 'react-redux'

class FileManagementDetail extends Component {

    constructor() {
        super()

        this.state = {
            notifyDetail: '',
            previewVisible: false,
        }
    }

    componentWillMount() {
        this.searchParams = getSearchParams(this.props.location.search)

        this.fileMgtId = this.props.match.params.fileMgtId
        this.role = this.props.match.params.role
    }

    componentDidMount() {
        document.title = '文件管理详情'
        this.obtainDetail()
    }

    componentWillUnmount() {

    }

    render() {
        const {previewVisible, notifyDetail} = this.state

        let enclosureItem = <div></div>
        let pictureUrls = []
        if (!isObjEmpty(notifyDetail.enclosure) && notifyDetail.enclosure != '[]') {
            enclosureItem = notifyDetail.enclosure.map((item,index) =>{
                return(
                    <span className='principal-enclosure-layout' key={index}>
                    {
                        item.endsWith(".pdf") || item.endsWith(".doc") || item.endsWith(".docx") || item.endsWith(".xls") || item.endsWith(".xlsx") || item.endsWith(".rar") || item.endsWith(".zip") || item.endsWith(".7z") ?
                            //点击文件下载
                            <div><a href={item} download><Icon type="download"/>{notifyDetail.notifyRemarks[index].length > 15 ? notifyDetail.notifyRemarks[index].substr(0, 15) + "..." : notifyDetail.notifyRemarks[index]}</a></div>
                            :
                            <img src={item} className='principal-enclosure-img'
                                 onClick={this.handlePreview}/>
                    }
                        {
                            item.endsWith(".pdf") || item.endsWith(".doc") || item.endsWith(".docx") || item.endsWith(".xls") || item.endsWith(".xlsx") || item.endsWith(".rar") || item.endsWith(".zip") || item.endsWith(".7z") ? '' :
                                <span className='principal-enclosure-count'>({notifyDetail.enclosure.length}张)</span>
                        }
                </span>)
            })

            notifyDetail.enclosure.forEach((enclosure, index) => {
                pictureUrls.push(enclosure)
            })
        }

        const readedList = notifyDetail.readed
        const unReadList = notifyDetail.unRead
        const receiveItems = []

        if (!isObjEmpty(readedList) && readedList != '[]') {
            for (let i = 0; i < readedList.length; i++) {
                receiveItems.push(<span
                    className='notify-detail-modal-read'>{getStrValue(readedList[i], 'stuName') ?
                    getStrValue(readedList[i], 'stuName') : getStrValue(readedList[i], 'teacherName')}</span>)
            }
        }
        if (!isObjEmpty(unReadList) && unReadList != '[]') {
            for (let i = 0; i < unReadList.length; i++) {
                receiveItems.push(<span
                    className='notify-detail-modal-unread'>{getStrValue(unReadList[i], 'stuName') ?
                    getStrValue(unReadList[i], 'stuName') : getStrValue(unReadList[i], 'teacherName')}</span>)
            }
        }

        return (
            <div>
                {previewVisible ?
                    <ImagesViewer onClose={this.handleCancel} urls={pictureUrls}
                                  index={0}
                                  needPoint={pictureUrls.length <= 9}/> : ""}
                <div className='notify-detail-modal-layout'>
                    <div className='notify-detail-modal-content-layout'>
                        <div className='notify-detail-modal-content-header'>
                            <div className='notify-detail-modal-header-tilte'>{notifyDetail.noTitle}</div>
                            <span
                                className={notifyDetail.noStatu === '已读' ?
                                    'notify-item-statuAl' : 'notify-item-statuNo'}>{notifyDetail.noStatu}</span>
                        </div>
                        <div className='notify-detail-modal-content-text'
                             dangerouslySetInnerHTML={{
                                 __html: notifyDetail.noContent ?
                                     notifyDetail.noContent.replaceAll('\n', '<br/>')
                                     : ''
                             }}></div>
                        <div style={{padding: '10px'}}>
                            {enclosureItem}
                        </div>
                        <div className='notify-detail-modal-time'>{notifyDetail.noIssue}</div>
                        <div className='notify-detail-modal-time'>{notifyDetail.noTime}</div>
                    </div>
                </div>
            </div>
        )
    }

    obtainDetail = () => {

        let url = '', params = {}
        url = API.FILEMGT_DETAIL_TEACHER
        let id = this.props.userInfo.teacher.teacherId
        let type = this.role=='parent' ? 0 :1
        if (this.searchParams) {
            if(this.searchParams.personId){
                id = this.searchParams.personId
            }
            if(this.searchParams.type){
                type = this.searchParams.type
            }
        }

        console.log('this.props',this.props)
        params = {
            fileMgtId: this.fileMgtId,
            personId: id,
            type:type
        }
        Toast.loading('', 0)
        fetchGet(url, params).then(response => {
            Toast.hide()
            // alert(JSON.stringify(response));
            if (response && response.data) {
                let notifyBoBean = new NotifyBoBean()

                let item = response.data
                if (item) {
                    notifyBoBean.noId = getIntValue(item, 'fileMgtId')
                    notifyBoBean.noTitle = getStrValue(item, 'fileMgtTitle')
                    notifyBoBean.enclosure = getArrayValue(item, 'fileMgtFiles').length > 0
                        ? JSON.parse(getArrayValue(item, 'fileMgtFiles')) : []

                    notifyBoBean.unRead = getArrayValue(item, 'unRead')
                    notifyBoBean.readed = getArrayValue(item, 'read')

                    notifyBoBean.allCount = getIntValue(notifyBoBean.unRead, 'length') + getIntValue(notifyBoBean.readed, 'length')
                    notifyBoBean.noContent = getStrValue(item, 'fileMgtDetails')
                    notifyBoBean.noIssue = getStrValue(item, 'teacherName')
                    notifyBoBean.noTime = getStrValue(item, 'createDate')
                    notifyBoBean.notifyRemarks = getStrValue(item, 'fileMgtRemarks').split(",");

                    notifyBoBean.noStatu = ''
                }
                this.setState({
                    notifyDetail: notifyBoBean
                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            } else {
                Toast.fail('请求异常')
            }
        })
    }

    handlePreview = () => {
        this.setState({
            previewVisible: true,
        });
    }


    handleCancel = () => this.setState({previewVisible: false})
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(FileManagementDetail)
